<ideal-product-result-list [ids]="alternateIds()" view="grid"></ideal-product-result-list>
